import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";

// Interfaces
import { Response } from "@/interface/response.interface";
import { DigitalMenu } from "@/modules/business/digital/index";
import { DigitalMenuInterface } from "@/interface/business/digital-menu.interface.ts";
import { Translate as $t } from "@/plugins/translate";

/**
 * Digital menu Store Module
 */
export default {
  namespaced: true,

  state: {
    digitalMenu: null,
    success: false,
    message: "",
  },

  getters: {
    digitalMenu: (state: any): DigitalMenuInterface => state.digitalMenu,
    success: (state: any): boolean => state.success,
    message: (state: any): string => state.message,
  },

  mutations: {
    SET_DIGITAL_MENU_DETAILS(state: any, payload) {
      state.digitalMenu = payload;
    },

    SET_RESPONSE_STATE(state: any, payload) {
      state.success = payload?.success || false;
      state.message = payload?.message || "";
    },
  },

  actions: {
    async getDigitalMenu({ commit }: { commit: any }, { location_id }) {
      return await request
        .get<Response<DigitalMenuInterface>>(ENDPOINTS.DIGITAL_MENU(location_id))
        .then((response) => response.data)
        .then(async ({ data }) => {
          commit("SET_DIGITAL_MENU_DETAILS", new DigitalMenu(data));
          commit("SET_RESPONSE_STATE", { success: true, message: "" });
        })
        .catch(async ({ error }) => {
          commit("SET_DIGITAL_MENU_DETAILS", new DigitalMenu());
          commit("SET_RESPONSE_STATE", { success: false, message: error?.message || $t("something_went_wrong") });
        });
    },

    async updateDigitalMenu({ commit }: { commit: any }, { payload }) {
      const menu = { ...payload.menu };
      const imageUrls = ["banner", "icon", "qr_code"];
      await commit("SET_RESPONSE_STATE", null);

      for (const key of imageUrls) {
        if (menu[key] && menu[key].startsWith("http")) {
          delete menu[key];
        }
      }
      return await request
        .patch<Response<DigitalMenuInterface>>(ENDPOINTS.DIGITAL_MENU(payload.location_id), menu)
        .then((response) => response.data)
        .then(async ({ data }) => {
          commit("SET_DIGITAL_MENU_DETAILS", new DigitalMenu(data));
          commit("SET_RESPONSE_STATE", { success: true, message: $t("saved_successfully") });
        })
        .catch(async ({ error }) => {
          debugger;
          commit("SET_RESPONSE_STATE", {
            success: !!error?.success,
            message: error?.message || $t("saved_successfully"),
          });
        });
    },

    async createDigitalMenu({ commit }: { commit: any }, { payload }) {
      await commit("SET_RESPONSE_STATE", null);

      return await request
        .put<Response<DigitalMenuInterface>>(ENDPOINTS.DIGITAL_MENU(payload.location_id), payload.menu)
        .then((response) => response.data)
        .then(async ({ data }) => {
          commit("SET_DIGITAL_MENU_DETAILS", new DigitalMenu(data));
          commit("SET_RESPONSE_STATE", { success: true, message: $t("saved_successfully") });
        })
        .catch(async ({ error }) => {
          commit("SET_RESPONSE_STATE", {
            success: !!error?.success,
            message: error?.message || $t("something_went_wrong"),
          });
        });
    },

    async deleteDigitalMenu({ commit }: { commit: any }, payload) {
      return await request
        .delete<Response<any>>(ENDPOINTS.DIGITAL_MENU(payload.location_id))
        .then((response) => response.data)
        .then(async () => {
          await commit("SET_DIGITAL_MENU_DETAILS", new DigitalMenu(), { success: true });
        })
        .catch(async (error) => {
          await commit("SET_DIGITAL_MENU_DETAILS", { success: false, message: error?.error?.message });
          console.log(error);
        });
    },
  },
};
